module.exports = "<div class=\"contact\">\n<p><i class=\"fa fa-envelope-o fa-3x\"></i> nick@nicksmithconsulting.org.uk</p>\n<p><i class=\"fa fa-linkedin fa-3x\"></i> uk.linkedin.com/in/nickajsmith82</p>\n<p><i class=\"fa fa-twitter fa-3x\"></i> @nickajsmith82</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/jonshilton/Projects/nick-smith-app/src/app/pages/contact/contact.component.html
// module id = ../../../../../src/app/pages/contact/contact.component.html
// module chunks = 0